import Header from "component/Header/Header";
import SingleLogInForm from "component/SingleLogInForm/SingleLogInForm";

const Login = () => {
  const link = "./vales";

  return (
    <div>
      <Header />
      <div>
        <SingleLogInForm
          link={link}
          textsLoginPage={true}
          startText={"login"}
          rol={"ROLE_EMPRESA"}
        />
      </div>
    </div>
  );
};
export default Login;
